import FetchData from '@ezviz/FetchData';
/** Action 类型 */
// 获取应用信息
export const FILLUSERINFO = 'FILLUSERINFO';
// 获取accessToken
export const ASYNC_GET_ACCESSTOKEN = 'ASYNC_GET_ACCESSTOKEN';
export const ASYNC_GET_AREA = 'ASYNC_GET_AREA';
export const ASYNC_GET_APPKEY = 'ASYNC_GET_APPKEY';

/** Action 创建函数 */
export const fillUserInfo = data => {
  return ({
    type: FILLUSERINFO,
    data,
  })
}
export const getAccessTokenSuccess = data => ({
  type: ASYNC_GET_ACCESSTOKEN,
  data,
});
export const getAreaSuccess = data => ({
  type: ASYNC_GET_AREA,
  data,
});
export const getAppKeySuccess = data => ({
  type: ASYNC_GET_APPKEY,
  data,
});
export const asyncGetAccessToken = () => {
  return (dispatch) => {
    const success = (data) => {
      if (data.retcode === 0 && data.data.code ==200) {
        setTimeout(()=>{
          dispatch(getAccessTokenSuccess(data.data.data.accessToken));
          dispatch(getAreaSuccess(data.data.data.areaDomain));
        },3000)
        // 测试
      } else {
        dispatch(getAccessTokenSuccess('mock-accessToken'));
        dispatch(getAreaSuccess('mock-area'));
      }
    }
    const error = (err) => {
      console.log("err",err)
    }
    const fetchData = new FetchData('/user/accessToken/get', {
      method: 'POST',
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData.then((res) => {
      success(res)
    }).catch(e => {
      error(e)
    })
  };
};
export const asyncGetAppKey = () => {
  return (dispatch) => {
    const success = (data) => {
      if (data.code === 0 && data.data) {
        setTimeout(()=>{
          dispatch(getAppKeySuccess(data.data.appKey));
        },3000)
        
      }
    }
    const error = (err) => {
      console.log("err",err)
    }
    const fetchData = new FetchData('/appInfo/get', {
      method: 'GET',
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData.then((res) => {
      success(res)
    }).catch(e => {
      error(e)
    })
  };
};

